"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSTHOG_FEATURE_FLAGS = void 0;
/**
 * PostHog feature-flag keys, used for both server-side bootstrap evaluation
 * (`lib/server/posthog-bootstrap/middleware.js`) and client-side flag reads
 * via `posthog.getFeatureFlag(...)` / `posthog.isFeatureEnabled(...)`.
 *
 * Flag reload after identify() is disabled via `advanced_disable_feature_flags`
 * in the provider init — server-evaluated bootstrap values are the source of
 * truth. To add a new flag: register it in PostHog, add the key here, and add
 * the consumer's flag check inline.
 */
// Co-located with the rest of the PostHog code so consumers find feature flags
// at the same barrel as the provider + hook. More named exports may be added
// (typed flag accessors, etc.); a default export would force anonymous imports.
// eslint-disable-next-line import/prefer-default-export
exports.POSTHOG_FEATURE_FLAGS = {
    AI_GOTS: 'ai_gots',
    COMMUNITY_INTERNAL_TEST: 'community-internal-test',
    COMMUNITY_EMPLOYEE_TEST: 'community-employee-test',
    COMMUNITY_YON_LAUREN_INITIAL_TEST: 'yon-lauren-initial-test',
    // AI Video Guide Desktop Test - Segment Experiments
    AI_GUIDE_SEGMENT_A: 'ai-video-guide-desktop-a',
    AI_GUIDE_SEGMENT_B: 'ai-video-guide-desktop-b',
    AI_GUIDE_SEGMENT_C: 'ai-video-guide-desktop-c',
    AI_GUIDE_SEGMENT_D: 'ai-video-guide-desktop-d',
    // AI Video Guide Mobile Test - Segment Experiments
    AI_GUIDE_MOBILE_SEGMENT_A: 'ai-video-guide-mobile-a',
    AI_GUIDE_MOBILE_SEGMENT_B: 'ai-video-guide-mobile-b',
    AI_GUIDE_MOBILE_SEGMENT_C: 'ai-video-guide-mobile-c',
    AI_GUIDE_MOBILE_SEGMENT_D: 'ai-video-guide-mobile-d',
    AI_ORACLE_CARD_WEB: 'ai-oracle-card-web',
    AI_TAROT_WEB: 'ai-tarot-web',
    // Divination cohort flags
    AI_DIVINATION_A: 'ai-divination-a',
    AI_DIVINATION_B: 'ai-divination-b',
    AI_DIVINATION_C: 'ai-divination-c',
    AI_DIVINATION_D: 'ai-divination-d',
    // AI-761: Daily Divination Card platform and feature gates
    AI_DIVINATION_DESKTOP: 'ai-divination-desktop',
    AI_DIVINATION_MOBILE: 'ai-divination-mobile',
    AI_DIVINATION_TAROT: 'ai-divination-tarot',
    AI_DIVINATION_ORACLE_CARDS: 'ai-divination-oracle', // planned — not yet live in PostHog
    AI_DIVINATION_HOROSCOPE: 'ai-divination-horoscope', // planned — not yet live in PostHog
};
